module.exports = __webpack_public_path__ + "img/adaa88f.png";